<template>
  <v-dialog v-model="dialog" persistent max-width="520">
    <v-card class="rm">
      <div class="rm__icon" :class="{ 'rm__icon--blocked': !options.canDelete }" aria-hidden="true">
        <v-icon>{{ options.canDelete ? "mdi-delete-alert-outline" : "mdi-eye-off-outline" }}</v-icon>
      </div>
      <p class="rm__title">{{ options.title }}</p>
      <p v-if="options.text" class="rm__text">{{ options.text }}</p>
      <div class="rm__actions">
        <v-btn text large @click="finish(null)">{{ options.canDelete || options.canHide ? "Anulare" : "Închide" }}</v-btn>
        <v-btn v-if="options.canDelete" large color="error" depressed @click="finish('delete')">
          <v-icon left>mdi-delete-outline</v-icon>Șterge
        </v-btn>
        <v-btn v-else-if="options.canHide" large class="btn-green" @click="finish('hide')">
          <v-icon left>mdi-eye-off-outline</v-icon>Ascunde
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Delete of a Configurare row: an unused one can be deleted; one with history cannot (the server refuses),
 * so the dialog explains why and offers to hide it instead.
 * ask({ title, text, canDelete, canHide }) resolves 'delete', 'hide' or null.
 */
export default {
  name: "RemoveDialog",
  data() {
    return {
      dialog: false,
      options: {},
      resolve: null,
    };
  },
  methods: {
    ask(options) {
      this.options = options || {};
      this.dialog = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    finish(choice) {
      this.dialog = false;
      if (this.resolve) this.resolve(choice);
      this.resolve = null;
    },
  },
};
</script>

<style scoped>
.rm {
  padding: 26px 26px 20px;
}
.rm__icon .v-icon {
  font-size: 40px;
  color: var(--brick);
}
.rm__icon--blocked .v-icon {
  color: var(--amber);
}
.rm__title {
  margin: 10px 0 10px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.3;
  color: var(--ink);
  overflow-wrap: anywhere;
}
.rm__text {
  margin: 0 0 22px;
  color: var(--ink-2);
  line-height: 1.5;
}
.rm__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}
</style>
